import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Lock, ArrowLeft } from 'lucide-react';
import PasswordSetForm from '../../components/PasswordSetForm';
import clientPortalService from '../../services/clientPortalService';

const PortalChangePassword = () => {
  const navigate = useNavigate();

  const handleSubmit = async (newPassword, currentPassword) => {
    await clientPortalService.changePassword(currentPassword, newPassword);

    const info = clientPortalService.getClientInfo() || {};
    if (info.must_change_password !== undefined) {
      info.must_change_password = false;
      localStorage.setItem('client_portal_contact', JSON.stringify(info));
    }

    if (info.is_first_login || info.profile_needs_update) {
      navigate('/portal/profile-setup');
    } else if (!info.pin_created) {
      navigate('/portal/pin-setup');
    } else if (!info.intake_completed) {
      navigate('/portal/intake');
    } else {
      navigate('/portal/dashboard');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 shadow-xl border border-white/20">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-500 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg shadow-purple-500/25">
              <Lock className="w-8 h-8 text-white" />
            </div>
          </div>
          <PasswordSetForm mode="change" onSubmit={handleSubmit} />
          <div className="mt-6 text-center">
            <Link
              to="/portal/dashboard"
              className="inline-flex items-center gap-2 text-purple-300 hover:text-white transition-colors text-sm"
            >
              <ArrowLeft className="w-4 h-4" />
              Cancel
            </Link>
          </div>
        </div>
        <p className="text-center text-purple-300/60 text-sm mt-6">
          Client Portal
        </p>
      </div>
    </div>
  );
};

export default PortalChangePassword;
